import React from "react"
import Slider from "react-slick"
import { Link } from "gatsby"
import arrowLeft from "../images/home/carrousel-arrow-left.svg"
import arrowRight from "../images/home/carrousel-arrow-right.svg"

// Voice image
import employer1 from "../images/voice/employer1.webp"
import employer2 from "../images/voice/employer2.webp"
import employer4 from "../images/voice/employer4.webp"
import employer5 from "../images/voice/employer5.webp"
// Arrow right
import arrowRightLink from "../images/home/arrow-right.svg"

const EmployersCarousel = () => {
  // Arrows style
  function SampleNextArrow(props) {
    const { className, onClick } = props
    return (
      <div
        className={className}
        onClick={onClick}
        role="button"
        tabIndex="0"
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            onClick()
          }
        }}
      >
        <img src={arrowLeft} alt="carrousel-arrow-left" />
      </div>
    )
  }

  function SamplePrevArrow(props) {
    const { className, onClick } = props
    return (
      <div
        className={className}
        onClick={onClick}
        role="button"
        tabIndex="0"
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            onClick()
          }
        }}
      >
        <img src={arrowRight} alt="carrousel-arrow-right" />
      </div>
    )
  }

  // Config Settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1150,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <div className="col-container">
      <div className="review-container desktop">
        <Slider {...settings}>
          <Link to="/employers-voice/#employer1">
            <div className="flex-center-card">
              <div key={"eCard1"} className="card">
                <div className="card-content">
                  <div className="img-text">
                    <h3 className="red">企業担当者様</h3>
                    <img
                      src={employer1}
                      alt="employer1"
                      width="96"
                      height="96"
                    />
                    <p>製造業</p>
                  </div>
                  <div className="text">
                    <p>
                      貴社を通じて入社した二名とも、非常に頑張ってくれていますし、他メンバーからも好評です。性格も良く、知識も豊富なので、あっという間に社内で絶大な信用を受け、馴染んでくれています。貴社を通じて雇用......
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Link>
          <Link to="/employers-voice/#employer4">
            <div className="flex-center-card">
              <div key={"eCard2"} className="card">
                <div className="card-content">
                  <div className="img-text">
                    <h3 className="red">企業担当者様</h3>
                    <img
                      src={employer4}
                      alt="employer4"
                      width="96"
                      height="96"
                    />
                    <p>物流</p>
                  </div>
                  <div className="text">
                    <p>
                      Kさんですが、業務習得の水準も非常に高く、遅刻などもなく勤怠も問題ありません。一度教えたことをすぐに覚えて自分のモノにして、業務の処理速度も入社して1か月の人と思えないほど早く、私が指導した.........
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Link>
          <Link to="/employers-voice/#employer5">
            <div className="flex-center-card">
              <div key={"eCard3"} className="card">
                <div className="card-content">
                  <div className="img-text">
                    <h3 className="red">企業担当者様</h3>
                    <img
                      src={employer5}
                      alt="employer4"
                      width="96"
                      height="96"
                    />
                    <p>製造業</p>
                  </div>
                  <div className="text">
                    <p>
                      3か月前に入社したDさんですが、社内でもとても評判が良いです。周囲とも協力しながらうまく業務を遂行してくれていますし、とても責任感がありで、今は品質管理の中でもキーパーソンになってくれていま….........
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Link>
          <Link to="/employers-voice/#employer2">
            <div className="flex-center-card">
              <div key={"eCard4"} className="card">
                <div className="card-content">
                  <div className="img-text">
                    <h3 className="red">企業担当者様</h3>
                    <img
                      src={employer2}
                      alt="employer4"
                      width="96"
                      height="96"
                    />
                    <p>物流</p>
                  </div>
                  <div className="text">
                    <p>
                      Yさんですが、入社頂いてから3ヶ月が経過し、業務内容をしっかり把握した上で迅速かつ丁寧・的確に対応頂いております。呑み込みが早い上、依頼の意図をくみ取り一歩先を行くと言いますか、何らかのプラス….........
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </Slider>
        <div class="link-cta">
          <a href="/employers-voice" className="red">
            <img src={arrowRightLink} alt="arrow-right" />
            <span>全ての企業担当者様の声を見る</span>
          </a>
        </div>
      </div>
      <div className="review-container mobile">
        <div className="flex-center-card">
          <div key={"eCard1"} className="card">
            <div className="card-content">
              <div className="img-text">
                <h3 className="red">企業担当者様</h3>
                <img src={employer1} alt="employer1" width="96" height="96" />
                <p>製造業</p>
              </div>
              <div className="text">
                <p>
                  貴社を通じて入社した二名とも、非常に頑張ってくれていますし、他メンバーからも好評です。性格も良く、知識も豊富なので、あっという間に社内で絶大な信用を受け、馴染んでくれています。貴社を通じて雇用......
                </p>
                <div class="link-cta">
                  <a href="/employers-voice" className="red">
                    <span>全ての企業担当者様の声を見る</span>
                    <img src={arrowRightLink} alt="arrow-right" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EmployersCarousel
